import { Payment, PaymentLineItem, PaymentLineItemNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: PaymentLineItemNameFragment) {
	return instance.id;
}

export function amount(
	instance: Pick<PaymentLineItem, "amount" | "localAmount"> & {
		payment: Pick<Payment, "isInLocalCurrency" | "localCurrency">;
	},
) {
	return instance.payment.isInLocalCurrency
		? Fields.localAmount(instance.localAmount, instance.payment.localCurrency)
		: Fields.amount(instance.amount);
}
